import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterSidebarComponent } from './components/filter-sidebar/filter-sidebar.component';
import { DefaultNameIconComponent } from './components/default-name-icon/default-name-icon.component';
import { NotFoundResultComponent } from '../../../not-found-result/not-found-result.component';
import { SearchFieldDirective } from './directives/search-field.directive';
import { DragDropFilesDirective } from './directives/drag-drop-files.directive';
import { FilesUploadComponent } from './components/files-upload/files-upload.component';
import { ResourceUploadComponent } from './components/resource-upload/resource-upload.component';
import { SingleFileUploadComponent } from './components/single-file-upload/single-file-upload.component';
import { ScrollableTabsComponent } from './components/scrollable-tabs/scrollable-tabs.component';
import { FileUploadUiComponent } from './components/file-upload-ui/file-upload-ui.component';
import { SplitTitlePipe } from './pipes/split-title.pipe';
import { TodayYesterdayPipe } from './pipes/today-yesterday.pipe';
import { TimeDayZonePipe } from './pipes/time-day-zone.pipe';
import { FilterDataPipe } from './pipes/filter-data.pipe';
import { UploadAudioVideoComponent } from './components/upload-audio-video/upload-audio-video.component';
import { CustomAlertMessageComponent } from './components/custom-alert-message/custom-alert-message.component';
import { UploadVideoAudioFileComponent } from './components/upload-video-audio-file/upload-video-audio-file.component';
import { AudioVideoModelComponent } from './components/audio-video-model/audio-video-model.component';
import { DeleteModalComponent } from './components/delete-modal/delete-modal.component';
import { MatProgressBarModule, MatProgressSpinnerModule } from '@angular/material'
import { StripHtmlPipe } from './pipes/strip-html.pipe';
import { UploadFileComponent } from './components/upload-file/upload-file.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollableDragDropTabsComponent } from './components/scrollable-drag-drop-tabs/scrollable-drag-drop-tabs.component';



@NgModule({
  declarations: [FilterSidebarComponent, DefaultNameIconComponent, SearchFieldDirective, DragDropFilesDirective, FilesUploadComponent, NotFoundResultComponent, ResourceUploadComponent, SingleFileUploadComponent, ScrollableTabsComponent,ScrollableDragDropTabsComponent, FileUploadUiComponent,SplitTitlePipe, TodayYesterdayPipe, TimeDayZonePipe, FilterDataPipe, UploadVideoAudioFileComponent, AudioVideoModelComponent, UploadAudioVideoComponent, CustomAlertMessageComponent, DeleteModalComponent, StripHtmlPipe, UploadFileComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DragDropModule 
  ],
  exports: [
  	FilterSidebarComponent,
  	DefaultNameIconComponent,
  	SearchFieldDirective,
  	DragDropFilesDirective,
    FilesUploadComponent,
    NotFoundResultComponent,
    ResourceUploadComponent,
    SingleFileUploadComponent,
    ScrollableTabsComponent,
    ScrollableDragDropTabsComponent,
    FileUploadUiComponent,
    SplitTitlePipe,
    TodayYesterdayPipe,
    TimeDayZonePipe,
    FilterDataPipe,
    UploadAudioVideoComponent,
    CustomAlertMessageComponent,
    UploadVideoAudioFileComponent,
    AudioVideoModelComponent,
    DeleteModalComponent,
    MatProgressSpinnerModule,
    StripHtmlPipe,
    UploadFileComponent,
    MatProgressBarModule 
  ]
})
export class SharedModule { }
